var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21058 0L2.02637 5.21053H8.39479L5.21058 0Z",
    fill: "#838383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39469 11.5789C9.83355 11.5789 11 10.4125 11 8.97369C11 7.53483 9.83355 6.36842 8.39469 6.36842C6.95583 6.36842 5.78943 7.53483 5.78943 8.97369C5.78943 10.4125 6.95583 11.5789 8.39469 11.5789Z",
    fill: "#838383"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.6579H4.63158V11.2895H0V6.6579Z",
    fill: "#838383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.acf8b781ea936c52b3980418bb4ac30f.svg";
export { ForwardRef as ReactComponent };